import { render } from "./UserTask.vue?vue&type=template&id=4a9e583a"
import script from "./UserTask.vue?vue&type=script&lang=js"
export * from "./UserTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__